import ScrollReveal from "@/components/feature/ScrollReveal";

const ahisFeedbackFormUrl =
  "https://docs.google.com/forms/d/e/1FAIpQLSeETVSBPO16xyK_48EwDz-Vg-1hlD0_K9pXKRDEjbAkJNN6lA/viewform?usp=publish-editor";

export default function ContactSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-white dark:bg-dark-bg">
      <div className="px-4 md:px-6 lg:px-8">
        <ScrollReveal>
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-brand-50 dark:bg-brand-500/10 text-brand-600 dark:text-brand-400 text-xs font-semibold uppercase tracking-wider mb-4">
              Get in Touch
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 dark:text-white mb-3">
              Contact Presuni
            </h2>
            <p className="text-sm md:text-base text-gray-500 dark:text-gray-400 max-w-xl mx-auto">
              Reach out for quotes, partnerships, or general inquiries. We reply within 24 hours.
            </p>
            <p className="text-sm md:text-base text-gray-500 dark:text-gray-400 max-w-xl mx-auto mt-2">
              Early users of AHIS can also share product feedback via the
              {" "}
              <a
                href={ahisFeedbackFormUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-brand-600 dark:text-brand-400 hover:underline"
              >
                AHIS feedback form
              </a>
              .
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {[
            {
              icon: "ri-map-pin-line",
              title: "Address",
              detail: "10 Winrush Close, Dudley, DY3 2NE, United Kingdom",
            },
            {
              icon: "ri-mail-line",
              title: "Email",
              detail: "info@presuni.co.uk",
              href: "mailto:info@presuni.co.uk",
            },
            {
              icon: "ri-phone-line",
              title: "Phone",
              detail: "+44 (0) 7788 1322 63",
              href: "tel:+447788132263",
            },
          ].map((item, i) => (
            <ScrollReveal key={item.title} delay={i + 1}>
              <div className="p-6 rounded-2xl bg-gray-50 dark:bg-dark-card border border-gray-100 dark:border-dark-border text-center hover:border-brand-200 dark:hover:border-brand-500/30 transition-all duration-300">
                <div className="w-12 h-12 rounded-full bg-brand-50 dark:bg-brand-500/10 flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-xl text-brand-500`} />
                </div>
                <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-2">
                  {item.title}
                </h3>
                {item.href ? (
                  <a
                    href={item.href}
                    className="text-sm text-gray-500 dark:text-gray-400 hover:text-brand-500 transition-colors"
                    rel="nofollow"
                  >
                    {item.detail}
                  </a>
                ) : (
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    {item.detail}
                  </p>
                )}
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}